import React, { useEffect, useMemo, useState } from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldDateRanger,
  FieldInput,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectWasteReceptionPoint,
  FieldSelectGroup,
  FieldSelectDriver,
  FieldSelectVehicle,
  FieldSelectProfession,
  FieldSelectContainerType,
  FieldSelectSeries,
  NumberingSeries,
  FieldSelectRegion,
  FieldSelectMaterial,
} from 'shared-pages';
import { useRootStore } from 'store';
import { Field } from 'formik';

/* ----------------------- where builder ------------------------------ */

export function buildWhereFromFilterValues(values): string {
  let where: Record<string, any> = {};
  const ctId = values.containertypeId ?? null;

  if (values) {
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
    if (values.collectorId) where = { ...where, collectorId: values.collectorId };
    if (values.wastereceptionpointId)
      where = { ...where, wastereceptionpointId: values.wastereceptionpointId };
    if (values.driverId) where = { ...where, driverId: values.driverId };
    if (values.vehicleId) where = { ...where, vehicleId: values.vehicleId };
    if (values.wasteOriginTypeId) where = { ...where, wasteOriginTypeId: values.wasteOriginTypeId };
    if (values.wasteDestinationTypeId)
      where = { ...where, wasteDestinationTypeId: values.wasteDestinationTypeId };

    if (values.regionId) {
      where = { ...where, '$collectionpoint.regionId$': values.regionId };
    }
    if (values.professionId) {
      where = { ...where, '$collectionpoint.professionId$': values.professionId };
    }
    if (values.addressNomos) {
      where = { ...where, '$collectionpoint.addressNomos$': values.addressNomos };
    }

    if (values.groupName) where = { ...where, colpointGroupName: values.groupName };
    if (values.driverName) where = { ...where, driverName: values.driverName };
    if (values.vehiclePlateNumber)
      where = { ...where, vehiclePlateNumber: values.vehiclePlateNumber };
    if (values.professionName) where = { ...where, colpointProfessionName: values.professionName };

    if (values.code) {
      where = { ...where, code: { $like: `%${values.code}%` } }; // partial search
    }

    if (ctId !== null && ctId !== undefined && ctId !== '') {
      where = { ...where, '$collectionLines.containertypeId$': Number(ctId) };
    }
    if (values.materialId) {
      where = { ...where, '$collectionLines.materialId$': Number(values.materialId) };
    }

    if (values.seriesId) where = { ...where, seriesId: values.seriesId };
  }

  console.log('where', values, where);
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */

export const Filters = ({ onChange, initialValues, disable = false }) => {
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  // compute base defaults from props
  const filters = useMemo(
    () => ({
      collectorId: initialValues?.collectorId ?? undefined,
      wastereceptionpointId: initialValues?.wastereceptionpointId ?? undefined,
      regionId: initialValues?.regionId ?? undefined,
      wasteOriginTypeId: initialValues?.wasteOriginTypeId ?? undefined,
      wasteDestinationTypeId: initialValues?.wasteDestinationTypeId ?? undefined,
      addressNomos: initialValues?.addressNomos ?? undefined,
      startDate: initialValues?.startDate ?? null,
      endDate: initialValues?.endDate ?? null,
      collectionPointId: initialValues?.collectionPointId ?? null,
      groupId: initialValues?.groupId ?? undefined,
      vehicleId: initialValues?.vehicleId ?? null,
      driverId: initialValues?.driverId ?? null,
      professionId: initialValues?.professionId ?? null,
      containertypeId: initialValues?.containertypeId ?? null,
      materialId: initialValues?.materialId ?? null,
      seriesId: initialValues?.seriesId ?? null,
    }),
    [initialValues],
  );

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldDateRanger as={FormCol} label="Συλλογή από" name="startDate" name2="endDate" />
        <FieldSelectCollector as={FormCol} />
        <FieldSelectWasteReceptionPoint as={FormCol} />
        <FieldSelectRegion as={FormCol} />

        <FieldSelectGroup as={FormCol} label="Κατηγορία" name="groupId" />
        <FieldSelectDriver as={FormCol} label="Οδηγός" name="driverId" />
        <FieldSelectVehicle as={FormCol} label="Όχημα" name="vehicleId" />
        <FieldSelectProfession as={FormCol} label="Επάγγελμα" name="professionId" />
        <FieldSelectContainerType as={FormCol} name="containertypeId" label="Τύπος Περιέκτη" />
        <FieldSelectMaterial as={FormCol} />
        <FieldSelectSeries
          as={FormCol}
          label={t('Σειρά Αρίθμησης Εντύπου')}
          name="seriesId"
          seriestypeId={NumberingSeries.Collections}
        />
      </Row>
    </FormFilterCard>
  );
};
